import { Typeahead } from "react-bootstrap-typeahead";
import { Card, CardBody, Col, Form } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { RemotetypeAheadHeading } from "../../../../Constant";
import { MOVIE_LIST, REMOTE_TYPEAHEAD_HEADING } from "../../../../Data/FormWidgets";

const RemoteTypeAhead = () => {
  return (
    <Col sm="12" md="6">
      <Card>
        <CommonCardHeader title={RemotetypeAheadHeading} span={REMOTE_TYPEAHEAD_HEADING} />
        <CardBody>
          <div id="remote">
            <Form className="theme-form">
              <div>
                <Typeahead options={MOVIE_LIST} placeholder="Choose Option" id="Remote TypeAhead"/>
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RemoteTypeAhead;
